import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { ReduxState } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import SLPStatic from 'utilities/slp/static/static.index';
import { createQuestionTitle } from '../questionsTypes.script';
import { extractTitle } from 'scripts/string';

const SLPStaticQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: () => true,
        submit: () => true,
    }));
    const question = props.question;
    const [title, setTitle] = useState(question.title);

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);

    return (
        <SLPStatic
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            labelColor={props.form?.question_color}
            dir={props.form.direction}
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPStaticQuestion));
